import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "media-input" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "btns" }
const _hoisted_5 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tab", { 'active': _ctx.type === tab.key }]),
          key: tab.key,
          onClick: ($event: any) => (_ctx.type = tab.key)
        }, _toDisplayString(tab.label), 11, _hoisted_3))
      }), 128))
    ]),
    (_ctx.type === 'video')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_Input, {
            value: _ctx.videoSrc,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.videoSrc) = $event)),
            placeholder: "请输入视频地址，e.g. https://xxx.mp4"
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close())),
              style: {"margin-right":"10px"}
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }),
            _createVNode(_component_Button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.insertVideo()))
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("确认")
              ])),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.type === 'audio')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_Input, {
            value: _ctx.audioSrc,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.audioSrc) = $event)),
            placeholder: "请输入音频地址，e.g. https://xxx.mp3"
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.close())),
              style: {"margin-right":"10px"}
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }),
            _createVNode(_component_Button, {
              type: "primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.insertAudio()))
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("确认")
              ])),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}